import { render } from "./list.vue?vue&type=template&id=dc25ca1a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=dc25ca1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dc25ca1a"

export default script